import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";

const HomePage = lazy(() => import("./pages/HomePage.js"));
const SignPage = lazy(() => import("./pages/SignPage.js"));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage.js"));
const HowItWorksPage = lazy(() => import("./pages/HowItWorksPage.js"));
const LegalReportPage = lazy(() => import("./pages/LegalReportPage.js"));
const AdminPage = lazy(() => import("./pages/AdminPage.js"));
const DocumentLandingPage = lazy(() => import("./pages/DocumentLandingPage.js"));
const BundleLandingPage = lazy(() => import("./pages/BundleLandingPage.js"));
const SignBundlePage = lazy(() => import("./pages/SignBundlePage.js"));
const VerifyPage = lazy(() => import("./pages/VerifyPage.js"));
const IosignoCallbackPage = lazy(() => import("./pages/IosignoCallbackPage.js"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage.js"));

function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center text-slate-500">
      Caricamento...
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/sign" element={<SignPage />} />
        <Route path="/sign-bundle" element={<SignBundlePage />} />
        <Route path="/d/:id" element={<DocumentLandingPage />} />
        <Route path="/b/:id" element={<BundleLandingPage />} />
        <Route path="/iosigno-callback/:cb" element={<IosignoCallbackPage />} />
        <Route path="/verify" element={<VerifyPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/relazione-tecnica" element={<LegalReportPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
